import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button, useViewport } from '@tryhackme/thm-ui-components';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
import crown from 'src/images/pngs/experiments/rooms/congratulations-full-screen/promote-premium-crown.png';
import { StyledContentWrapper, StyledSubTitle, StyledTitle } from '../../congratulations-full-screen.styles';
import type { PromotePremiumProps } from '../../congratulations-full-screen.types';
import { promotedInformation } from './promote-premium-step.constants';
import { usePromoteCheckout } from './promote-premium-step.hooks';
import { ButtonWrapper, CheckIcon, ColoredSpan, StyledDetailBlock, StyledImg, StyledTable, XIcon } from './promote-premium-step.styles';
export const PromotePremiumStep = ({
  isFirstFourRooms
}: PromotePremiumProps) => {
  const {
    onCheckout,
    isLoading
  } = usePromoteCheckout();
  const isDarkMode = useIsDarkMode();
  const {
    width
  } = useViewport();
  const isMobile = width < BREAKPOINTS.MOBILE;
  return <StyledContentWrapper data-content="promote-premium" data-sentry-element="StyledContentWrapper" data-sentry-component="PromotePremiumStep" data-sentry-source-file="promote-premium-step.tsx">
      <header>
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="promote-premium-step.tsx">
          {isFirstFourRooms ? <>
              Premium learners <ColoredSpan $isDarkMode={isDarkMode}>get hired</ColoredSpan> 3x faster!
            </> : <>
              Get <ColoredSpan $isDarkMode={isDarkMode}>unlimited</ColoredSpan> hours of AttackBox, smarter tools,{' '}
              <br />
              and faster results with Premium!
            </>}
        </StyledTitle>
        <StyledSubTitle data-sentry-element="StyledSubTitle" data-sentry-source-file="promote-premium-step.tsx">
          Premium unlocks everything you need to go pro — with nothing in your way.
          {isFirstFourRooms && <>
              <br />
              Learn Smarter. Practice More. Get Hired.
            </>}
        </StyledSubTitle>
      </header>

      <StyledTable $isMobile={isMobile} $isDarkMode={isDarkMode} data-sentry-element="StyledTable" data-sentry-source-file="promote-premium-step.tsx">
        <thead>
          <tr>
            <th id="feature" aria-hidden="true" />
            <th id="free">Free</th>
            <th id="premium">
              <ColoredSpan $isDarkMode={isDarkMode} data-sentry-element="ColoredSpan" data-sentry-source-file="promote-premium-step.tsx">Premium</ColoredSpan>
            </th>
          </tr>
        </thead>
        <tbody>
          {promotedInformation.map(({
          title,
          free,
          premium
        }) => <tr key={title}>
              <td headers="feature">{title}</td>
              <td headers="free">
                <AvailabilityDetail {...free} />
              </td>
              <td headers="premium">
                <AvailabilityDetail {...premium} />
              </td>
            </tr>)}
        </tbody>
        <tfoot>
          <tr>
            {!isMobile && <>
                <th aria-hidden="true" />
                <th aria-hidden="true" />
              </>}
            <td colSpan={isMobile ? 3 : 1}>
              <ButtonWrapper data-sentry-element="ButtonWrapper" data-sentry-source-file="promote-premium-step.tsx">
                <Button isLoading={isLoading} isDisabled={isLoading} onClick={onCheckout} data-sentry-element="Button" data-sentry-source-file="promote-premium-step.tsx">
                  Get Premium
                </Button>
              </ButtonWrapper>
            </td>
          </tr>
        </tfoot>
        <StyledImg src={crown} data-sentry-element="StyledImg" data-sentry-source-file="promote-premium-step.tsx" />
      </StyledTable>
    </StyledContentWrapper>;
};
interface AvailabilityDetailProps {
  check: boolean;
  text?: string;
}
const AvailabilityDetail = ({
  check,
  text
}: AvailabilityDetailProps) => <StyledDetailBlock data-sentry-element="StyledDetailBlock" data-sentry-component="AvailabilityDetail" data-sentry-source-file="promote-premium-step.tsx">
    {check ? <CheckIcon icon={faCheck} /> : <XIcon icon={faXmark} />}
    {text && <span>{text}</span>}
  </StyledDetailBlock>;